import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from '@weave-mui/material';
import { useAuth } from '../hooks/useAuth';
import { usePermissions } from '../hooks/usePermissions';
const RoleIndicator = ({ className, style }) => {
    const { user, viewerMode } = useAuth();
    const { role } = usePermissions();
    const theme = useTheme();
    if (!user) {
        return null;
    }
    const getRoleColor = (r) => {
        switch (r) {
            case 'admin':
                return theme.palette.error.main;
            case 'viewer':
                return theme.palette.primary.main;
            default:
                return theme.palette.text.secondary;
        }
    };
    const color = getRoleColor(role ?? 'viewer');
    const label = viewerMode
        ? 'Viewer (Preview)'
        : (role ?? 'viewer').charAt(0).toUpperCase() + (role ?? 'viewer').slice(1);
    const title = viewerMode ? 'Viewing as Viewer — your real role is Admin' : `Role: ${role}`;
    const badgeStyle = {
        display: 'inline-block',
        padding: '3px 10px',
        borderRadius: '12px',
        fontSize: '11px',
        fontWeight: 600,
        color,
        border: `1px solid ${color}`,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        ...(viewerMode ? { borderStyle: 'dashed' } : {}),
        ...style,
    };
    return (_jsx("span", { className: className, style: badgeStyle, title: title, children: label }));
};
export default RoleIndicator;
